import { SortOrder } from "src/app/shared/types/sort.order";

export class GetQualitySurveysCommand {
  constructor(
    public page: number = 1,
    public pageSize: number = 25,
    public subService: string = '',
    public sortBy: string = '',
    public sortOrder: SortOrder) { }
}
